import { UseCase } from "../../useCase"
import { B2BRepository } from "../../../repositories/b2bRepository"
import { UpdateB2BContentRequest } from "./request"
import { UpdateB2BContentResponse } from "./response"

export class UpdateB2BContentUseCase implements UseCase<UpdateB2BContentRequest, UpdateB2BContentResponse> {
	private _repository

	constructor({ B2BRepository }: { B2BRepository: B2BRepository }) {
		this._repository = B2BRepository
	}

	exec(content: UpdateB2BContentRequest) {
		return this._repository.updateB2BContent(content)
	}
}
